// import { randomHexColorWithArray } from 'random-hex-color-generator';
// import React, { useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import {
//     BarChart,
//     XAxis,
//     YAxis,
//     Tooltip,
//     Bar,
//     ResponsiveContainer,
//     Cell,
// } from "recharts";

function SalesByCategoryGraph({ salesByCategoryData, active, colorsList }) {
    // const navigate = useNavigate();
    // const location = useLocation();

    // const [colors, setColors] = useState([]);

    // useEffect(() => {
    //     if(!colorsList?.length) {
    //         const colorsArray = randomHexColorWithArray(salesByCategoryData.length);
    //         setColors(colorsArray);
    //     }
    //     else {
    //         setColors(colorsList);
    //     }
    // }, [salesByCategoryData, colorsList]);

    // const toSalesByCategoryStats = (category) => {
    //     if(location.pathname.split('/').reverse()[0] === 'sales-by-category') {
    //         navigate(
    //             `${category.toLowerCase().split(' ').join('-')}`,
    //             {
    //                 state: {
    //                     category: category,
    //                     graphData: salesByCategoryData,
    //                     colorsList: colors
    //                 }
    //             }
    //         );
    //     }
    //     else {
    //         navigate(
    //             `${location.pathname.split('/').slice(0, -1).join('/')}/${category.toLowerCase().split(' ').join('-')}`,
    //             {
    //                 state: {
    //                     category: category,
    //                     graphData: salesByCategoryData,
    //                     colorsList: colors
    //                 }
    //             }
    //         );
    //     }
    // }

    return (
        <div className="border-[1px] rounded-lg border-[#EAEAEA] w-full min-h-[80vh] p-5 flex flex-col gap-4">
            <h1 className="font-urbanist-regular font-semibold text-[16px] leading-6">Categories</h1>

            <div className="m-auto">
                <h1 className='font-urbanist-regular font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            {/* <ResponsiveContainer width='100%' height='100%'>
                <BarChart
                    layout="vertical"
                    data={salesByCategoryData}
                    margin={{
                        top: 0,
                        right: 20,
                        bottom: 10,
                        left: 20,
                    }}
                >
                    <XAxis 
                        tickCount={6} 
                        tickLine={false}
                        tickMargin={15} 
                        type="number" 
                        domain={[0, 100]} 
                        unit={'%'} 
                    />

                    <YAxis
                        tickLine={false}
                        tickMargin={15} 
                        dataKey="name"
                        type="category"
                        width={150} 
                    />

                    <Tooltip cursor={{ fill: 'transparent' }} />

                    <Bar
                        dataKey="percentage"
                        fill="#00a0fc" 
                    >
                        {
                            salesByCategoryData.map((entry, index) => (
                                <Cell 
                                    stroke={`${active === entry.name && '#BCFCD7'}`} 
                                    strokeWidth={6} 
                                    key={`cell-${index}`} 
                                    fill={colors[index % 20]} 
                                    onClick={() => toSalesByCategoryStats(entry.name)}
                                />
                            ))
                        }
                    </Bar>
                </BarChart>
            </ResponsiveContainer> */}
        </div>
    )
}

export default SalesByCategoryGraph;
